import React from 'react';
import { useTranslation } from 'react-i18next';

import PageContainer from 'components/common/PageContainer';
import PageTitle from 'components/common/Layout/PageTitle';
import SEO from 'components/common/SEO';
import { YOUTUBE_CHANNEL_URL } from 'constants/social';
import TutorialCard from './TutorialCard';
import { TUTORIALS } from './tutorials';

import styles from './styles.module.scss';

const Tutorials: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      {/* Заголовок и описание страницы берутся из записи /tutorials в seoRoutes.json */}
      <SEO canonicalUrl={`${window.location.origin}/tutorials`} />
      <div className={styles.content}>
        <PageTitle>{t('tutorials.heading')}</PageTitle>

        <div className={styles.intro}>
          <p className={styles.introText}>{t('tutorials.intro')}</p>
          <a
            className={styles.channelButton}
            href={YOUTUBE_CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('tutorials.channel')}
          </a>
        </div>

        <div className={styles.grid}>
          {TUTORIALS.map((tutorial, index) => (
            <TutorialCard key={tutorial.id} tutorial={tutorial} number={index + 1} />
          ))}
        </div>
      </div>
    </PageContainer>
  );
};

export default Tutorials;
